<template>
  <div>
    <div class="card card-rounded card-shadow border-0 mb-3" :class="{'card-bg-media': !offer.description.imgUrl}">
      <img :src="offer.description.imgUrl" class="card-img-top" v-if="offer.description.imgUrl">
      <div class="card-bg-media-wrapper" v-else>
        <div style="transform: translate(-20px, -60px)">
          <PeppersBackground></PeppersBackground>
        </div>
      </div>
      <div class="card-body">
        <h5>{{ $p(offer.description.title, { offered_amount: offer.maxAmount }) }}</h5>
        <p class="text-muted">{{ $p(offer.description.excerpt, { offered_amount: offer.maxAmount }) }}</p>
        <div class="d-flex justify-content-between align-items-center">
          <button @click="goToPreApprovedLoanAgreement()"
                  class="btn btn-sm rounded-pill btn-primary text-nowrap px-3 ml-auto">{{ $t('Offer.applyButton') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PeppersBackground from '@shared/components/PeppersBackground'
import settings from '@shared/settings'

export default {
  name: 'Offer',
  components: { PeppersBackground },
  props: ['offer'],
  methods: {
    goToPreApprovedLoanAgreement() {
      const query = (!this.isBasicOffer() && settings.isAppToBrowserRedirectEnabled()) ? { w: '' } : {}
      this.$router.push({ name: 'loan-form-with-offer-id', params: { offerId: this.offer.id }, query })
    },
    isBasicOffer() {
      return this.offer.id === '1'
    }
  }
}
</script>
